<div class="map-container">
  <div class="map-frame">
    <div #mapElement style="height: 100%"></div>
  </div>
</div>
